module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-metals.1b5de594.png";